import { render, staticRenderFns } from "./affiliated-person.vue?vue&type=template&id=ce6405fa&"
import script from "./affiliated-person.vue?vue&type=script&lang=js&"
export * from "./affiliated-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports